import { bool, number, string } from 'prop-types';
import React from 'react';
import { View } from 'react-native';

import { LAYOUT, THEME } from '../../../../reactor/common';
import { Motion, Text } from '../../../../reactor/components';
import styles from './Chapter.style';

const { MOTION: { DURATION } } = THEME;

const Chapter = ({
  motion, number: chapter, title, viewed, visibility, ...inherit
}) => {
  const centered = inherit.style === 'centered';
  const { LANDSCAPE } = LAYOUT.VIEWPORT;
  const motionProps = {
    disabled: !motion || !LANDSCAPE,
    preset: 'fadeLeft',
    visible: viewed || visibility > 0.33,
  };
  const textProps = { color: inherit.color, headline: true, level: LANDSCAPE ? 2 : 4 };

  return (
    <View style={[styles.container, centered && styles.centered]}>
      { chapter && (
        <Motion {...motionProps}>
          <Text {...textProps} style={styles.number}>
            {chapter + (centered ? '' : '. ')}
          </Text>
        </Motion>)}

      { title && (
        <Motion {...motionProps} delay={DURATION} style={[styles.content, centered && styles.contentCentered]}>
          <Text {...textProps}>
            {title}
          </Text>
        </Motion>)}
    </View>
  );
};

Chapter.propTypes = {
  motion: bool,
  number,
  title: string,
  viewed: bool,
  visibility: number.isRequired,
};

Chapter.defaultProps = {
  motion: true,
  number: undefined,
  title: undefined,
  viewed: false,
};

export default Chapter;
